import MfTable from './src/mf-table'

MfTable.install = function (Vue) {
  Vue.component(MfTable.name, MfTable)
}

export default MfTable
